"use client";

export default function ErrorPage({ retry }: { error: Error & { digest?: string }; retry: () => void }) {
  return (
    <section role="alert" className="mx-auto max-w-lg space-y-4 px-6 py-16">
      <h1 className="text-xl font-semibold">This page couldn’t load</h1>
      <p className="text-sm text-zinc-400">Try loading the page again. If the problem continues, return to Monitoring to check your workers.</p>
      <div className="flex gap-4">
        <button onClick={retry} className="rounded-lg bg-violet-600 px-4 py-2 text-sm text-white">Try again</button>
        <a href="/monitoring" className="rounded-lg border border-zinc-700 px-4 py-2 text-sm">Open Monitoring</a>
      </div>
    </section>
  );
}
